import React, { Component } from "react";

import ApplicatedQuestionItem from "./CorrectQuestionItem";

import "./styles.css";

class ApplicatedQuestionItemsMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answer_question: undefined
    };

    this.getIfIsAnswer = this.getIfIsAnswer.bind(this);
  }

  componentDidMount() {
    const found = this.props.answerGiven.find(
      item => item.questionId === this.props.questionId
    );
    this.setState({ answer_question: found });
  }

  getIfIsAnswer(index) {
    if (index + 1 === this.state.answer_question?.answer_given) {
      return true;
    }
    return false;
  }

  render() {
    return (
      <ul className="applicated-question-item-list">
        {this.props.items.map((item, index) => (
          <li key={item.id}>
            <ApplicatedQuestionItem
              finished={this.props.finished}
              questionId={this.props.questionId}
              questionType={this.props.questionType}
              itemData={item}
              userAnswer={this.getIfIsAnswer(index)}
              answerChanger={this.props.answerChanger}
            />
          </li>
        ))}
      </ul>
    );
  }
}

export default ApplicatedQuestionItemsMenu;
